// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu[data-v-71a2411e] {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.menu .menu-item[data-v-71a2411e] {\n  width: 100%;\n  text-align: left;\n  padding: 5px;\n  border-bottom: 1px solid #ccc;\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
